import React from 'react'
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { FieldInput, FieldDate } from '../../Elements';
import { PageLoader } from '../../../../shared_elements';
import { backendDateFormat, displayDateFormat, fieldDateFormat, } from '../../../../constants';
const headerArr = ['Module', "Description", '% Fund Allocation', 'Starting Fund Balance', 'Balance as of Date',]

const SVClaimTable = ({ type, mrRate, is_llp_description, loader, handleSvClaim, svClaimErrors }) => {
    const updatedHeader = !is_llp_description ? headerArr?.filter(ele => ele !== "Description") : headerArr
    return (
        <div className="table-responsive table-height">
            <table className="table-sticky common-table" style={{ border: "1px solid #dddddd" }}>
                <thead>
                    <tr>
                        {updatedHeader?.map((head, index) => <th key={index} className="label">{head} {type == 'add' && (head=="% Fund Allocation" || head =="Balance as of Date")? <sup className="reqStar"> * </sup> : null}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {mrRate?.engine_split_details?.length > 0 ? mrRate?.engine_split_details?.map((claim, index) => {
                        return (<tr className='table-row' key={index + claim?.module}>
                            <td align='left'>
                                <div>
                                    <h6 >{claim?.module_name}</h6>
                                </div>
                            </td>
                            {is_llp_description ? <td align='left'><div><h6>{claim?.description}</h6></div></td> : null}
                            <td align='left'>
                                <div>
                                    <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
                                        <FieldInput
                                            value={claim?.fund_allocation_percentage}
                                            type={type}
                                            percentage={true}
                                            keyParam="fund_allocation_percentage"
                                            accept='number'
                                            disable={type === 'view' || type === "edit"}
                                            updateField={(type, value) => handleSvClaim("change", type, index, value)}
                                            handleOnFocus={() => handleSvClaim('error', 'fund_allocation_percentage', index)}
                                            defaultValue ={0}
                                        />
                                        {type !== "view"  ? <h6>%</h6> :null }
                                    </div>

                                </div>
                                {type !== "view" && svClaimErrors && svClaimErrors[index]?.fund_allocation_percentage ? <h6 className="error-msg">{svClaimErrors[index]?.fund_allocation_percentage}</h6> : null}
                            </td>
                            <td align='left'>
                                <div>
                                    <div style={{ display: "flex", alignItems: "center", width: "135px" }}>
                                        <h6>{type !== "view" ||!claim?.starting_fund  ? mrRate?.currency === "USD" || mrRate?.currency === null ? "US$" : mrRate?.currency : null}</h6>
                                        <FieldInput
                                            value={claim?.starting_fund}
                                            type={type}
                                            currency={true}
                                            keyParam="starting_fund"
                                            accept='number'
                                            disable={type === 'view' || type === "edit"}
                                            updateField={(type, value) => handleSvClaim("change", type, index, value)}
                                            defaultValue ={0}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td align='left'>
                                <div >
                                    {type !== "view" ?
                                        <DatePicker
                                            dateFormat={fieldDateFormat}
                                            selected={claim?.balance_as_of_date && moment(claim?.balance_as_of_date).isValid() ? moment(claim.balance_as_of_date) : ""}
                                            onChange={(value) => handleSvClaim("change", "balance_as_of_date", index,moment(value).format(backendDateFormat))}
                                            onFocus={() => handleSvClaim('error', 'balance_as_of_date', index)}
                                            showYearDropdown
                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            disabled={type === 'view' || type === "edit"}
                                            popperPlacement="bottom"
                                        />
                                        : <h6 >{claim?.balance_as_of_date ? moment(claim?.balance_as_of_date).format(displayDateFormat) : '--'}</h6>}
                                </div>
                                {type !== "view" && svClaimErrors && svClaimErrors[index]?.balance_as_of_date ? <h6 className="error-msg">{svClaimErrors[index]?.balance_as_of_date}</h6> : null}
                            </td>
                        </tr>)
                    }) :
                        <tr >
                            <td colSpan={is_llp_description ? "5" : "4"} style={{ textAlign: 'center', padding: '10px' }}>
                                No records found.
                            </td>
                        </tr>

                    }
                </tbody>
            </table>
            {loader ? <PageLoader /> : null}
        </div>
    )
}

export default SVClaimTable